import { render, staticRenderFns } from "./new-historiqueCotationGaz.vue?vue&type=template&id=90da8526"
import script from "./new-historiqueCotationGaz.vue?vue&type=script&lang=js"
export * from "./new-historiqueCotationGaz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports